import { DlgTitleWithCloseBtn } from 'ctls/modal/DlgTitleWithCloseBtn';
import { Modal, ModalWrap } from 'ctls/modal/Modal';
import { usePromise } from 'hooks/usePromise';
import { useRefComponent } from 'hooks/useRefComponent';
import { tc } from 'language/i18nkey';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { CheckBox } from './check/CheckBox';

/**
 * 문서복제 팝업
 * 선태항목의 종류.
 * 제목및 본문, 최신버전 및 첨부파일, 카테고리, 태그, 모델명, 쎔네일 이미지.
 */

export type CopyItem = 'title-content' | 'version-attach' | 'category' | 'thumnail';

type Props = {
  show(): Promise<{ items: CopyItem[] } | null>;
};
export const PopCopyDocItem = forwardRef<Props, {}>((props, ref) => {
  const [visible, setVisible] = useState(false);
  const promise = usePromise<{}, { cmd?: string }>();
  const [copyItems, setCopyItems] = useState<CopyItem[]>([]);

  useImperativeHandle(ref, () => ({
    show: () => {
      return new Promise((resolve, reject) => {
        promise.current = { resolve, reject };
        // setCopyItems([]);
        // setAllChecked(false);
        // 기본 모두 선택 상태로.
        setCopyItems(['title-content', 'version-attach', 'category', 'thumnail']);
        setAllChecked(true);
        setVisible(true);
      });
    },
  }));

  const handleCopyItem = (item: CopyItem) => {
    if (copyItems.includes(item)) {
      setCopyItems(copyItems.filter((item) => item !== item));
    } else {
      setCopyItems([...copyItems, item]);
    }
  };

  const handleClose = () => {
    setVisible(false);
    promise.current.reject({ cmd: 'close' });
  };

  const handleSelect = () => {
    promise.current.resolve({ items: copyItems });
    setVisible(false);
  };

  const [allChecked, setAllChecked] = useState(false);
  const handleAllChecked = (checked: boolean) => {
    setAllChecked(checked);
    if (checked) {
      setCopyItems(['title-content', 'version-attach', 'category', 'thumnail']);
    } else {
      setCopyItems([]);
    }
  };

  if (!visible) return null;

  return (
    <Modal onClick={(e) => e.stopPropagation()}>
      <Body>
        <DlgTitleWithCloseBtn title={tc('i18n_doc_copy_title')} onClose={handleClose} />
        <Cnts>
          <Guide>{tc('i18n_doc_copy_desc')}</Guide>

          <CheckBox label={tc('i18n_select_all')} checked={allChecked} onChange={handleAllChecked} />
          <Hr />
          <CheckBox
            label={tc('i18n_doc_copy_item_title_content')}
            checked={copyItems.includes('title-content')}
            onChange={() => handleCopyItem('title-content')}
          />
          <CheckBox
            label={tc('i18n_doc_copy_item_version_attach')}
            checked={copyItems.includes('version-attach')}
            onChange={() => handleCopyItem('version-attach')}
          />
          <CheckBox
            label={tc('i18n_category')}
            checked={copyItems.includes('category')}
            onChange={() => handleCopyItem('category')}
          />
          {/* <CheckBox label="태그" checked={copyItems.includes('tag')} onChange={() => handleCopyItem('tag')} />
          <CheckBox label="모델명" checked={copyItems.includes('model')} onChange={() => handleCopyItem('model')} /> */}
          <CheckBox
            label={tc('i18n_thumnail_image')}
            checked={copyItems.includes('thumnail')}
            onChange={() => handleCopyItem('thumnail')}
          />
        </Cnts>
        <Bottom>
          <Btn onClick={() => handleSelect()}>{tc('i18n_confirm')}</Btn>
        </Bottom>
      </Body>
    </Modal>
  );
});

PopCopyDocItem.displayName = 'PopCopyDocItem';

export const usePopCopyDocItem = () => useRefComponent<Props>(PopCopyDocItem);

const Hr = styled.hr`
  height: 1px;
  background-color: #d6deec;
`;

const Bottom = styled.div`
  padding: 0 3.2rem 2.3rem 3.2rem;
  text-align: center;
`;

const Guide = styled.div`
  font-size: 1.4rem;
  font-weight: 400;
  color: #2a2c2f;
  padding: 1.1rem 0;
`;

const Cnts = styled.div`
  padding: 0 3.2rem 2.3rem 3.2rem;
  display: flex;
  height: 1px;
  flex-grow: 1;
  gap: 1.6rem;
  overflow-y: auto;
  flex-direction: column;
`;

const Body = styled(ModalWrap)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 40rem;
  max-width: 36rem;
`;

const Btn = styled.button`
  width: 100%;
  max-width: 29.6rem;
  height: 4.8rem;
  font-size: 1.6rem;
  font-weight: 700;
  background-color: #123069;
  color: #fff;
  border-radius: 10rem;
  line-height: 4.8rem;
`;
